<template>
  <div class="offset-md-0 offset-1">
    <button class="btn breadcrumb-button mx-md-3 mx-0 mb-3"
            @click="loadAdminData"
            ref="btnTextToggle"
    >
      {{CONSTANTS.ADMIN_AP_VIEW_TITLE}}
    </button>
  </div>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import CONSTANTS from "@/store/constants";
import APUserSelectModal from "./APUserSelectModal";
import InvoicesPOFiltersMixin from "@/mixins/InvoicesPOFiltersMixin";
import InvoicesAndPOMixin from "@/mixins/InvoicesAndPOMixin";

export default {
  computed: {
    ...mapGetters(["currentUser"]),
  },
  mixins: [InvoicesPOFiltersMixin, InvoicesAndPOMixin],
  data(){
    return{
      isAPUSerButtonClicked: false,
    }
  },
  methods:{
    ...mapMutations(["setIsLoading", "setViewingAPUserDataFor","setErrorMessage","setAPUserId"]),
    ...mapActions(["fetchPurchaseOrders",'fetchInvoiceDashboardData']),
    loadAdminData(){
        this.showAPAdminViewModal()
        this.isAPUSerButtonClicked = true;
    },
    showAPAdminViewModal(){
      document.documentElement.style.overflow = "hidden";
      this.$modal.show(APUserSelectModal,{},
          {name: 'APUserSelectModal',
            width: 800,
            adaptive: true,
            height : 350,
            scrollable: false,
          }
          ,{
            'close': this.beforeClose,
            'closed': () => {
              document.documentElement.style.overflow = "auto";
            },
            closeAfterSelected: (userDetails) => {
              this.beforeClose(userDetails)
            },
            'closeAndDisplayYourPOInvoice':this.closeAndShowInvoicePO,
          })
    },
    async beforeClose(userDetails) {
      /*
        userDetails === 1 when the modal is just closed without searching for any contact in the modal. i.e-'close' event is called
        for closing the modal.
      */
      if (userDetails === 1) {
        this.isAPUSerButtonClicked = false;
      }
      this.$modal.hide('APUserSelectModal')
      if (userDetails && userDetails.length > 0) {
        this.isAPUSerButtonClicked = true
        try{
          this.setViewingAPUserDataFor(userDetails[0].fullName)
          this.setAPUserId(userDetails[0].id)
          await this.populatePOInvoiceTableWithAPUserViewData()
        } catch {
          this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
        }finally{
          await this.resetFilterPreferences()
        }
      }
      document.documentElement.style.overflow = "auto";
    },
    async closeAndShowInvoicePO() {
      this.$modal.hide('APUserSelectModal')
      try {
        this.setViewingAPUserDataFor(null)
        this.setAPUserId(null)
        this.isAPUSerButtonClicked = false;
        await this.populatePOInvoiceTableWithAPUserViewData()
      } catch {
        this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
      } finally {
        await this.resetFilterPreferences()
      }
      document.documentElement.style.overflow = "auto";
    },
    async populatePOInvoiceTableWithAPUserViewData() {
        await this.fetchInvoiceDashboardData()
        await this.fetchPurchaseOrders();
        this.routeToAllInvoices()
    },
    async resetFilterPreferences() {
      await this.getAllNamesForFilter()
      this.resetPoTableUserPreferences()
      this.poFiltersList.isFiltersReloaded = false
      this.resetInvoiceTableUserPreferences()
    }
  }
}
</script>

<style scoped>
.btn-custom{
  font-size: 14px !important;
  height: 38px;
  text-align: center;
  padding: 0.375rem 0.5rem;
  border-radius: 68px;
  min-width: 280px;
}
</style>

